<div class="sidebar d-flex flex-column h-100">
  <div class="menu flex-grow-1">
    <h6 class="p-3 text-muted">Menu</h6>
    <ul class="nav flex-column">
      <li class="nav-item">
        <a
          routerLink="/app/dashboard"
          class="nav-link"
          routerLinkActive="active bg-light text-success fw-bold"
        >
          <i class="bi bi-house-door-fill me-2"></i> Dashboard
        </a>
      </li>
      <li class="nav-item">
        <a
          routerLink="/app/planning"
          class="nav-link"
          routerLinkActive="active bg-light text-success fw-bold"
        >
          <i class="bi bi-calendar-event-fill me-2"></i> Planning
        </a>
      </li>
      <li class="nav-item">
        <a
          routerLink="/app/workday"
          class="nav-link"
          routerLinkActive="active bg-light text-success fw-bold"
        >
          <i class="bi bi-check2-square me-2"></i> Workday
        </a>
      </li>
      <li class="nav-item">
        <a
          routerLink="/app/profile"
          class="nav-link"
          routerLinkActive="active bg-light text-success fw-bold"
        >
          <i class="bi bi-person-fill me-2"></i> Profile
        </a>
      </li>
      <li class="nav-item">
        <a
          routerLink="/app/settings"
          class="nav-link"
          routerLinkActive="active bg-light text-success fw-bold"
        >
          <i class="bi bi-gear-fill me-2"></i> Settings
        </a>
      </li>
      <li class="nav-item">
        <a
          routerLink="/app/map"
          class="nav-link"
          routerLinkActive="active bg-light text-success fw-bold"
        >
          <i class="bi bi-geo-alt-fill me-2"></i> Map
        </a>
      </li>
      <li class="nav-item">
        <a
          routerLink="/app/userdata"
          class="nav-link"
          routerLinkActive="active bg-light text-success fw-bold">
          <i class="bi bi-geo-alt-fill me-2"></i> User Data
        </a>
      </li>
    </ul>
    
    <!-- Bouton de déconnexion -->
    <div class="mt-auto p-3 border-top">
      <button 
        (click)="logout()" 
        class="btn btn-outline-danger w-100 d-flex align-items-center justify-content-center">
        <i class="bi bi-box-arrow-right me-2"></i>
        Déconnexion
      </button>
    </div>
  </div>
</div>
